export const callable = (/android|iphone|blackberry|iemobile|opera mini/i).test(navigator.userAgent.toLowerCase());

export const isSp = callable;



// WEBPACK FOOTER //
// ./common/userAgent.js